import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  passengerDetailsWizard: {
    margin: '20px 0px 20px',
    [Theme.breakpoints.up('md')]: {
      margin: '30px 0px 30px',
    },
  },
  passengerDetailsTitle: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  passengerDetailsDescription: {
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[3],
    lineHeight: '150%',
    marginTop: '10px',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
    '& b': {
      fontFamily: Theme.typography.base.semiBold,
    },
  },
  wizardWrapper: {
    padding: '0',
    boxShadow: '0px 2px 4px rgba(6, 21, 86, 0.15)',
  },
  wizardHeaderRoot: {
    padding: '20px 0px',
    [Theme.breakpoints.up('md')]: {
      padding: '30px 0px 20px',
    },
  },
  wizardTitle: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    lineHeight: '120%',
    marginBottom: '0px',
  },
  wizardSubtitle: {
    padding: '0',
  },
  wizardStepper: {
    padding: ' 0px 16px 40px',
    [Theme.breakpoints.up('md')]: {
      padding: ' 0px 24px 40px',
    },
    '& .MuiStepLabel-iconContainer': {
      display: 'none',
    },
  },
  wizardInline: {
    padding: '30px 0 40px 0',
    overflowY: 'auto',
    display: 'flex',
    [Theme.breakpoints.up('sm')]: {
      width: '100%',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  wizardStepWrapper: {
    padding: '0',
    flexBasis: '24%',
    [Theme.breakpoints.down('sm')]: {
      flexBasis: '19%',
    },
  },
  stepRoot: {
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: Theme.typography.size[3],
    fontFamily: Theme.typography.base.semiBold,
    '& svg': {
      [Theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    [Theme.breakpoints.down('md')]: {
      fontSize: Theme.typography.size[2],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[2],
      textAlign: 'left',
    },
  },
  wizardStepButton: {
    margin: '0',
    padding: '0',
    textWrap: 'nowrap',
    '& .MuiStepLabel-iconContainer': {
      [Theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    '& .MuiStepLabel-root': {
      width: '100%',
    },
    '& .MuiStepLabel-label': {
      color: Theme.palette.text.brand,
      borderBottom: `1px solid ${Theme.palette.border.divider}`,
      borderRadius: `${isCelebrity ? '0' : '8px 8px 0 0'}`,
      boxSizing: 'border-box',
      fontFamily: Theme.typography.base.semiBold,
      padding: '8px 12px',
      width: '100%',
    },
    '& .MuiStepLabel-label.MuiStepLabel-active': {
      backgroundColor: Theme.palette.surface.brand,
      borderBottom: `2px solid ${Theme.palette.primary.main}`,
    },
  },
  inputWrapper: {
    marginBottom: '34px',
    flexBasis: '48.5%',
    '&.input-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${Theme.palette.error.main} !important`,
        borderWidth: '1px',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      width: 'auto !important',
      marginTop: '34px',
      marginRight: '0',
      '&:first-child': {
        marginTop: '0 !important',
        marginRight: '0 !important',
      },
    },
  },
  inputboxWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  inputBox: {
    width: 'auto !important',
    marginRight: '0 !important',
    '& .MuiOutlinedInput-input': {
      height: '20px',
    },
    '&:last-child': {
      marginRight: '0',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: Theme.palette.gray[150],
    },
  },
  secondRowForm: {
    [Theme.breakpoints.down('md')]: {
      marginTop: '34px',
    },
  },
  inputLabel: {
    display: 'flex',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    marginBottom: '9px',
    '& > span svg': {
      color: Theme.palette.primary.light,
      width: '16px',
      height: '16px',
    },
    '& > span div': {
      maxHeight: '17px',
    },
  },
  errorMessage: {
    color: Theme.palette.error.main,
    fontFamily: Theme.typography.size[2],
    paddingTop: '10px',
    '&.no-padding-top': {
      paddingTop: '0',
    },
  },
  frequentFlyerWrapper: {
    justifyContent: 'space-between',
    marginTop: '0',
    '&:not(:nth-child(3), :last-child)': {
      marginTop: '30px',
    },
    '&:nth-child(3)': {
      marginTop: '0px',
    },
  },
  wizardFooter: {
    background: Theme.palette.gray[100],
    padding: '15px 40px 15px 15px',
    [Theme.breakpoints.down('md')]: {
      padding: '20px 20px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '15px 20px 15px 20px',
      height: '50px',
    },
  },
  wizardCta: {
    background: Theme.palette.gray[500],
    borderRadius: '3px',
    color: Theme.palette.white,
    width: '120px',
    [Theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '50px',
    },
  },
  guestInfoCtaWrapper: {
    margin: '0 0 0 auto',
    [Theme.breakpoints.down('sm')]: {
      margin: '0',
      width: '100%',
    },
  },
  infoIcon: {
    alignSelf: 'center',
    color: Theme.palette.primary.light,
    height: '15px',
    width: '15px',
  },
  travelerNumberInput: {
    [Theme.breakpoints.up('md')]: {
      marginBottom: '0',
    },
  },
  travelerNumberInputSecond: {
    [Theme.breakpoints.down('md')]: {
      marginRight: '0',
    },
  },
  redressNumberInput: {
    marginBottom: '0',
    [Theme.breakpoints.only('xl')]: {
      marginRight: '0 !important',
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: '0 !important',
    },
  },
  redressNumberInputSecond: {
    [Theme.breakpoints.down('sm')]: {
      flexGrow: '1',
    },
  },
  frequentFlyerInputs: {
    marginBottom: '0',
  },
  frequentFlyerNumberInput: {
    [Theme.breakpoints.down('lg')]: {
      marginRight: '0 !important',
    },
  },
  titleWithTooltip: {
    padding: '15px 16px 25px',
    fontSize: Theme.typography.size[3],
    display: 'flex',
    [Theme.breakpoints.only('md')]: {
      padding: '25px 24px 25px',
      fontSize: Theme.typography.size[4],
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '25px 24px 25px',
      fontSize: Theme.typography.size[4],
    },
    '& > span svg': {
      color: Theme.palette.primary.light,
      width: '16px',
      height: '16px',
      marginTop: '4px',
      marginLeft: '6px',
    },
    '& > span div': {
      maxHeight: '16px',
    },
  },
  fullWidth: {
    width: '100%',
  },
}));

export default useStyles;
